import { render, staticRenderFns } from "./BookCategoryPage.vue?vue&type=template&id=6d9dfbab&"
import script from "./BookCategoryPage.vue?vue&type=script&lang=js&"
export * from "./BookCategoryPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports